import request from '@/utils/request';

//抢购-秒杀

// export const doSecKill = (data) => {
//     return request({
//         method: "POST",
//         url: "/virtual/doSecKill",
//         data

//     })
// }

export const getSecOrderInfo = (params) => {
    return request({
        method: "GET",
        url: "/virtual/getSecOrderInfo",
        params

    });
};

export const getStartTime = () => {
    return request({
        method: "GET",
        url: "/virtual/getStartTime",

    });
};

export const getGoodsInfo = () => {
    return request({
        method: "GET",
        url: "/virtual/getGoodsInfo",
    });
};

export const getGoodsInfo2 = () => {
    return request({
        method: "GET",
        url: "/virtual/getGoodsInfo",
    });
};

//获取虚拟商品详情
export const getVirtualDetail = (params) => request({
    method: "GET",
    url: "/virtual/getGoodDetail",
    params
});

//补充用户信息
export const getConfirmVirtualOrder = params => {
    return request({
        methods: "GET",
        url: "/virtual/confirmVirtualOrder",
        params
    });
}

//获取两个虚拟商品
export const getGoodsInfoList = goodId => {
    return request({
        methods: "GET", url:
            "/virtual/getGoodsInfoList", params: {goodId}

    })
}
